import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as customBuild from './../../../../../ckCustomeBuild/build/ckeditor';
//import { UsersInit, RevisionHistoryAdapter } from '../ck-editor/revision-history-adapter';
import type { Editor } from '@ckeditor/ckeditor5-core';
// import type { AnnotationsUIs, CommentsRepository } from '@ckeditor/ckeditor5-comments';
import type { RevisionsRepository } from '@ckeditor/ckeditor5-revision-history';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { RevisionHistoryAdapter,  UsersInitWithOutRevision } from '../ckEditor-adapter';
import { UserProfile } from 'src/app/core/models/user';
import { revisionHistoryAccessTypeEnum } from 'src/app/core/models/ckEditor/revisionData';
// import type { TrackChanges } from '@ckeditor/ckeditor5-track-changes';
// Assuming customBuild.Editor.defaultConfig is your configuration object



// Now, use the modified configuration in your component


@Component({
	selector: 'app-ck-editor',
	templateUrl: './ck-editor.component.html',
	styleUrls: ['./ck-editor.component.scss']
})
export class CkEditorComponent {
	///////ckEditor////////////////////////////////////////////
	// public Editor = customBuild.Editor;
	// public editor!: Editor;
	// ownerComment: string = "This is a comment from the owner";
	//data: string = "This is a comment from the owner";

	// @ViewChild('sidebar', { static: true }) private sidebarContainer?: ElementRef<HTMLDivElement>;
	// @Output() public ready = new EventEmitter<Editor>();
	// public get editorConfig() {
	// 	return {
	// 		//initialData: new AppData,
	// 		extraPlugins: [UsersInit, RevisionHistoryAdapter],
	// 		sidebar: {
	// 			container: this.sidebar
	// 		},
	// 		licenseKey: 'ck5mZEpMWkFDWVZ4S2duV1lKcHFYcVEzWkcvMFRaSDFTa252QUlSa2xSbWdkclV3RE5tWXFFd0UwVDhDLU1qQXlNekE1TURZPQ==',
	// 		revisionHistory: {
	// 			editorContainer: document.querySelector('#editor-container'),
	// 			viewerContainer: document.querySelector('#revision-viewer-container'),
	// 			viewerEditorElement: document.querySelector('#revision-viewer-editor'),
	// 			viewerSidebarContainer: document.querySelector('#revision-viewer-sidebar')
	// 		},

	// 		collaboration: {
	// 			channelId: 'document-1'
	// 		},
	// 		autosave: {
	// 			save: (editor: { plugins: { get: (arg0: string) => any; }; }) => {
	// 				const revisionTracker = editor.plugins.get('RevisionTracker') as any;

	// 				return revisionTracker.update();
	// 			}
	// 		}
	// 	};
	// }

	// private readonly STORAGE_KEY = 'ckeditor-license-key';
	// //private licenseKey = '';
	// private licenseKey: string | null = null;


	// private sidebar = document.createElement('div');

	// private boundRefreshDisplayMode = this.refreshDisplayMode.bind(this);
	// private boundCheckPendingActions = this.checkPendingActions.bind(this);

	// public ngOnInit(): void {
	// 	//( window as any ).CKBox = ClassicEditorBuild.CKBox;
	// 	// Save the provided license key in the local storage.
	// 	this.licenseKey = window.localStorage.getItem(this.STORAGE_KEY) || window.prompt('Your license key');
	// 	if (this.licenseKey !== null) {
	// 		window.localStorage.setItem(this.STORAGE_KEY, this.licenseKey ? this.licenseKey : '');
	// 	}
	// }

	// public ngAfterViewInit(): void {
	// 	if (!this.sidebarContainer) {
	// 		throw new Error('Div container for sidebar was not found');
	// 	}

	// 	this.sidebarContainer.nativeElement.appendChild(this.sidebar);
	// }

	// public ngOnDestroy(): void {
	// 	window.removeEventListener('resize', this.boundRefreshDisplayMode);
	// 	window.removeEventListener('beforeunload', this.boundCheckPendingActions);
	// }

	// public onReady(editor: Editor): void {
	// 	this.editor = editor;
	// 	this.ready.emit(editor);

	// 	// Prevent closing the tab when any action is pending.
	// 	window.addEventListener('beforeunload', this.boundCheckPendingActions);

	// 	// Switch between inline and sidebar annotations according to the window size.
	// 	window.addEventListener('resize', this.boundRefreshDisplayMode);
	// 	this.refreshDisplayMode();
	// }
	// public resetLicenseKey(): void {
	// 	window.localStorage.removeItem(this.STORAGE_KEY);
	// 	window.location.reload();
	// }
	// private checkPendingActions(domEvt: any): void {
	// 	if (this.editor?.plugins.get('PendingActions').hasAny) {
	// 		domEvt.preventDefault();
	// 		domEvt.returnValue = true;
	// 	}
	// }

	// private refreshDisplayMode(): void {
	// 	const annotationsUIs = this.editor?.plugins.get('AnnotationsUIs');
	// 	const sidebarElement = this.sidebarContainer?.nativeElement;

	// 	if (window.innerWidth < 1070) {
	// 		sidebarElement?.classList.remove('narrow');
	// 		sidebarElement?.classList.add('hidden');
	// 		//annotationsUIs?.switchTo( 'inline' );
	// 	}
	// 	else if (window.innerWidth < 1300) {
	// 		sidebarElement?.classList.remove('hidden');
	// 		sidebarElement?.classList.add('narrow');
	// 		//annotationsUIs?.switchTo( 'narrowSidebar' );
	// 	}
	// 	else {
	// 		sidebarElement?.classList.remove('hidden', 'narrow');
	// 		//annotationsUIs?.switchTo( 'wideSidebar' );
	// 	}
	// }
	// public showEditorDataInConsole(evt: any): void {
	// 	const editorData = this.editor.data.get();

	// 	const trackChanges = this.editor.plugins.get('TrackChanges') as TrackChanges;
	// 	const comments = this.editor.plugins.get('CommentsRepository') as CommentsRepository;
	// 	const revisionsRepositoryPlugin = this.editor.plugins.get('RevisionsRepository') as RevisionsRepository;

	// 	const revisionsData = revisionsRepositoryPlugin.getRevisions();
	// 	const suggestionsData = trackChanges.getSuggestions();
	// 	const commentThreadsData = comments.getCommentThreads({
	// 		skipNotAttached: true,
	// 		skipEmpty: true
	// 	});
	// 	evt.preventDefault();
	// }

	// Now, use the modified configuration in your component
	//public Editor = customBuild.Editor.defaultConfig;
	public Editor = customBuild.Editor;
	@Input() data: string = '';
	@Input() accessType: revisionHistoryAccessTypeEnum = revisionHistoryAccessTypeEnum.All;
	@Output() childVariableChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() keyUpEvent = new EventEmitter<void>();
	commentVal = false;
	// public accessType = 3;
	public readonly: boolean = false;
	showEditor: boolean = true;
	public toolbarItem = [
		'undo',
		'redo',
		'findAndReplace',
		'|',
		'bold',
		'italic',
		'underline',
		'strikethrough',
		'link',
		'bulletedList',
		'numberedList',
		'todoList',
		'superscript',
		'subscript',
		'removeFormat',
		'|',
		'outdent',
		'indent',
		'alignment',
		'specialCharacters',
		'horizontalLine',
		'|',
		'imageUpload',
		'imageInsert',
		'blockQuote',
		'insertTable',
		// 'mediaEmbed',
		'|',
		'fontSize',
		'fontColor',
		'highlight',
		'fontFamily',
		'fontBackgroundColor',
		'|',
		'selectAll',
		// 'htmlEmbed',
		// 'showBlocks',
		// 'restrictedEditingException',
		'|',
		'heading'
	];

	accessManageFunction() {
		if (this.accessType === 1) {
			this.readonly = true;
			this.toolbarItem = [
				'undo',
				'redo',
				'|',
				'bold',
				'italic',
				'underline',
				'strikethrough',
				'link',
				'bulletedList',
				'numberedList',
				'todoList',
				'superscript',
				'subscript',
				'removeFormat',
				'|',
				'outdent',
				'indent',
				'alignment',
				'specialCharacters',
				'horizontalLine',
				'|',
				'imageUpload',
				'imageInsert',
				'blockQuote',
				'insertTable',
				// 'mediaEmbed',
				'|',
				'fontSize',
				'fontColor',
				'highlight',
				'fontFamily',
				'fontBackgroundColor',
				'|',
				// 'htmlEmbed',
				// 'showBlocks',
				// 'restrictedEditingException',
				'|',
				'heading'
			];
		}
		else if (this.accessType === 2) {
			// comment only
			this.readonly = false;
			this.commentVal = true;
			this.toolbarItem = [
				'undo',
				'redo',
				'findAndReplace',
				'|',
				'bold',
				'italic',
				'underline',
				'strikethrough',
				'link',
				'bulletedList',
				'numberedList',
				'todoList',
				'superscript',
				'subscript',
				'removeFormat',
				'|',
				'outdent',
				'indent',
				'alignment',
				'specialCharacters',
				'horizontalLine',
				'|',
				'imageUpload',
				'imageInsert',
				'blockQuote',
				'insertTable',
				// 'mediaEmbed',
				'|',
				'fontSize',
				'fontColor',
				'highlight',
				'fontFamily',
				'fontBackgroundColor',
				'|',
				'selectAll',
				// 'htmlEmbed',
				// 'showBlocks',
				// 'restrictedEditingException',
				'|',
				'heading'
			];
		}
		// else if (this.accessType === 3) {
		// 	this.showEditor = false; // Set showEditor to false
		// }

		else {
		}


	}
	public ngOnInit(): void {
		this.accessManageFunction();
		// if (saveComments) {
		// 	const parsedData = JSON.parse(saveComments)
		// 	this.comments = parsedData.comments
		// }
	}

	onDataChange() {
		// Emit the updated value to the parent when the childVariable changes
		this.childVariableChange.emit(this.data);
	}
	onKeyUp() {
		this.keyUpEvent.emit();
	}
	@ViewChild('sidebar', { static: true }) private sidebarContainer?: ElementRef<HTMLDivElement>;
	userInfo!: UserProfile;
	private sidebar = document.createElement('div');

	public get editorConfig() {

		return {
			commentsOnly: this.commentVal,
			removePlugins: ['Title'],
			extraPlugins: [UsersInitWithOutRevision(this.userInfo), RevisionHistoryAdapter('')],
			licenseKey: 'TzM4ZXFzODFYUnh6YUl5dEYzQ0ZxMVlBTWQrUGVHOWFQZXQvKzM2SloxQndRZ29vRGtxbE0rdkw5dmIwR25KWUFZST0tTWpBeU5EQTVNVFE9',

			// toolbar: {
			// 	items: [
			// 		'undo',
			// 		'redo',
			// 		'findAndReplace',
			// 		'|',
			// 		'bold',
			// 		'italic',
			// 		'underline',
			// 		'strikethrough',
			// 		'link',
			// 		'bulletedList',
			// 		'numberedList',
			// 		'todoList',
			// 		'superscript',
			// 		'subscript',
			// 		'removeFormat',
			// 		'|',
			// 		'outdent',
			// 		'indent',
			// 		'alignment',
			// 		'specialCharacters',
			// 		'horizontalLine',
			// 		'|',
			// 		'imageUpload',
			// 		'imageInsert',
			// 		'blockQuote',
			// 		'insertTable',
			// 		// 'mediaEmbed',
			// 		'|',
			// 		'fontSize',
			// 		'fontColor',
			// 		'highlight',
			// 		'fontFamily',
			// 		'fontBackgroundColor',
			// 		'|',
			// 		'selectAll',
			// 		'htmlEmbed',
			// 		'showBlocks',
			// 		'restrictedEditingException',
			// 		'|',
			// 		'heading'
			// 	],
			// 	outputType: 'html'
			// },
			toolbar: {
				items: this.toolbarItem
			},
			style: {
				definitions: []
			}
		};
	}

	public ngAfterViewInit(): void {
		// if (!this.sidebarContainer) {
		// 	throw new Error('Div container for sidebar was not found');
		// }

		// this.sidebarContainer.nativeElement.appendChild(this.sidebar);
	}
	public onChange({ editor }: ChangeEvent) {
		// this.updatedValue = editor?.data.get();
		// this.buttonActive = true;
	}
}
